export const TITLE = "activation.settings.general.title.text";
const FIRST_FILTER_TOOLTIP = "activation.settings.general.domain.tooltip.text";
const PLACEHOLDER = "activation.settings.general.domain.title.text";
export const FILTER_TITLE = "activation.settings.general.country.title.text";
export const SECOND_FILTER_TOOLTIP = "activation.settings.general.country.tooltip.text";
export const PROJECT_NAME = "activation.settings.general.name.title.text";
export const DISABLED_MAIN_DOMAIN_INPUT = "activation.settings.general.main.domain.disabled.tooltip";
